module.exports = __webpack_public_path__ + "img/18.4ef50aee.jpg";